import Box from "@mui/material/Box";
import WizardStep from "../../../../components/Wizard/WizardStep"
import useICPWizard from "../hooks/useICPWizard";
import { ReactNode } from "react";
import Typography from "@mui/material/Typography";
import Filters2 from "../../../filters/leads/Filters2";
import { Filter } from "../../../filters/FilterTypes";

type Props = {
    onCancel: () => void,
    steps: ReactNode
}

const SelectICPFilters = ({ onCancel, steps }: Props) => {
    const { handleNextStep, icp, onICPChange } = useICPWizard();

    return (
        <WizardStep
            onNext={handleNextStep}
            onCancel={onCancel}
            title="ICP Builder - Key Filters"
            subtitle="Ideal Customer Profile"
        >
            <Box display='flex' sx={{ height: '100%' }}>
                {steps}
                <Box sx={{ height: '100%', display: 'flex', flexDirection: 'column', rowGap: 4, width: '100%' }}>
                    <Box display='flex' flexDirection='column' rowGap={1}>                        
                        <Typography variant='body2'>Please select any filters that will apply to this ICP. You will be able to fine tune these in the next step.</Typography>
                    </Box>
                    <Filters2 onFiltersChanged={(newFilter: Filter) => onICPChange({ ...icp, primaryFilters: newFilter })} filter={icp.primaryFilters} />
                </Box>
            </Box>
        </WizardStep>
    )
}

export default SelectICPFilters;